module.exports = __webpack_public_path__ + "img/住院案件调解-影像信息@2x.d95c6c95.png";